const LANES = [
  { label: "Batch A", values: ["PDF", "PDF", "PDF"], color: "text-violet-300", border: "border-violet-500/30", bg: "bg-violet-500/10" },
  { label: "Batch B", values: ["PDF", "PDF", "PDF"], color: "text-cyan-300", border: "border-cyan-500/30", bg: "bg-cyan-500/10" },
  { label: "Batch C", values: ["PDF", "PDF", "PDF"], color: "text-amber-300", border: "border-amber-500/30", bg: "bg-amber-500/10" },
];

const PRINCIPLES = [
  ["Global ceiling", "A single configurable worker pool prevents per-user worker explosion."],
  ["Fair dispatch", "Active batches receive turns instead of one large batch occupying every slot indefinitely."],
  ["Dynamic capacity", "One active batch can consume spare capacity when no competing batch is waiting."],
  ["STOP-safe", "Queued PDFs are not dispatched after STOP; active PDFs retain cooperative cancellation."],
];

export default function FairScheduler() {
  return (
    <div className="space-y-4">
      <div>
        <p className="font-mono text-[10px] tracking-[0.25em] text-slate-500">FAIR SCHEDULER</p>
        <h4 className="mt-1 text-sm font-semibold text-white">Bounded multi-user PDF concurrency</h4>
        <p className="mt-1 text-xs text-slate-400">A global worker ceiling is shared intelligently between active batches. Capacity is reused when idle and distributed fairly when several users are processing at once.</p>
      </div>

      <div className="grid gap-3 md:grid-cols-[1fr_auto_1fr] md:items-center">
        <div className="space-y-2">
          {LANES.map((lane) => (
            <div key={lane.label} className={`rounded-xl border ${lane.border} ${lane.bg} p-2.5`}>
              <div className="mb-2 flex items-center justify-between">
                <span className={`text-[11px] font-semibold ${lane.color}`}>{lane.label}</span>
                <span className="font-mono text-[9px] text-slate-500">pending queue</span>
              </div>
              <div className="flex gap-1.5">
                {lane.values.map((v, i) => <span key={`${lane.label}-${i}`} className="rounded border border-white/10 bg-black/20 px-2 py-1 font-mono text-[9px] text-slate-400">{v}</span>)}
              </div>
            </div>
          ))}
        </div>

        <div className="hidden text-slate-600 md:block">→</div>

        <div className="rounded-2xl border border-purple-500/30 bg-gradient-to-br from-purple-500/15 to-violet-500/5 p-4 text-center">
          <p className="font-mono text-[9px] tracking-[0.18em] text-purple-300">FAIR DYNAMIC SCHEDULER</p>
          <p className="mt-2 text-2xl font-bold text-white">≤ 12</p>
          <p className="text-[10px] text-slate-400">global PDF workers</p>
          <p className="mt-3 text-[10px] leading-relaxed text-slate-500">One batch can use spare capacity alone; competing batches receive turns without creating per-user pools.</p>
        </div>
      </div>

      <div className="grid gap-2 sm:grid-cols-2">
        {PRINCIPLES.map(([title, desc], i) => (
          <div key={title} className="rounded-xl border border-white/10 bg-white/5 p-3">
            <div className="flex items-center gap-2">
              <span className="flex h-5 w-5 items-center justify-center rounded border border-purple-500/30 bg-purple-500/10 font-mono text-[9px] font-bold text-purple-300">0{i + 1}</span>
              <p className="text-xs font-semibold text-slate-200">{title}</p>
            </div>
            <p className="mt-1 text-[11px] leading-relaxed text-slate-500">{desc}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
